import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from "@medsurf/flat-facades";
import { FLAT_SETTINGS, type SettingControlModel } from "@medsurf/flat-services";

@Component({
    selector: "medsurf-changelog",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./changelog.component.html",
    styleUrls: ["./changelog.component.scss"],
    standalone: false
})
export class ChangelogComponent {
  readonly version: string = this.settings.version || '';
  readonly FlatModels = FlatModels;

  constructor(
    public releaseNoteAuthorFacade: FlatFacades.ReleaseNoteAuthorFacade,
    @Inject(FLAT_SETTINGS) private settings: SettingControlModel
  ) {}

  trackByRelease(
    index: number,
    item: FlatModels.ReleaseNoteAuthorModels.Release
  ) {
    return item.commit.id || index;
  }

  isActive(
    currentRelease: FlatModels.ReleaseNoteAuthorModels.Release | null | undefined,
    release: FlatModels.ReleaseNoteAuthorModels.Release
  ) {
    if (!release.released_at) return false;
    return (
      new Date(release.released_at).getTime() <=
      new Date(currentRelease?.released_at || Date.now()).getTime()
    );
  }
}
